export const loginRoute = () => '/login'
